import { Api } from "@/core/services/api.service";
import { QueryUrlBuilderService } from "@/core/services/queryUrlBuilder.service";

const fetchConnectorById = async (connectorId) => {
  const response = await Api.new().get(`connectors/${connectorId}`);

  return response.data;
};

const fetchConnectorList = async (pagination = false, options = {}) => {
  options = { properties: ["id", "name", "type", "fqn"] };
  const urlBuilder = new QueryUrlBuilderService("connectors").withFilters(options);
  if (pagination) {
    urlBuilder.withPagination();
  } else {
    // TMP FIX!!
    urlBuilder.withPagination(1, 500);
  }
  const url = urlBuilder.get();

  const response = await Api.new().get(url);

  return response.data;
};

const fetchConnectorOrganizationList = async (pagination = false, options = {}) => {
  const urlBuilder = new QueryUrlBuilderService("connector-organizations").withFilters(options);
  if (pagination) {
    urlBuilder.withPagination();
  }

  const response = await Api.new().get(urlBuilder.get());

  return response.data;
};

const fetchConfigurationById = async (configurationId) => {
  const response = await Api.new().get(`connector-organizations/${configurationId}`);

  return response.data;
};

const createConfiguration = async (newConnectorOrganizationData) => {
  return Api.new().post("connector-organizations", newConnectorOrganizationData);
};

const updateConfiguration = async (configurationId, configurationData) => {
  return Api.new().patch(`connector-organizations/${configurationId}`, configurationData, {
    headers: { "Content-Type": "application/merge-patch+json" },
  });
};

const deleteConfiguration = async (configurationId) => {
  return await Api.new().delete(`connector-organizations/${configurationId}`);
};

const launchPremiumFeatureConnector = async (action, values) => {
  const urlBuilder = new QueryUrlBuilderService("organizations/launch-generic-premium-feature-connector").withFilters({
    action: action,
    values: values,
  });
  const response = await Api.new().get(urlBuilder.get());

  return response.data;
};

const launchPremiumFeatureConnectorDispatchCircuitRulePatch = async (action, dispatchCircuitRuleId, values) => {
  const urlBuilder = new QueryUrlBuilderService(
    "dispatch-circuit-rules/" + dispatchCircuitRuleId + "/launch-premium-feature-connector"
  ).withFilters({ action: action });

  const response = await Api.new().patch(urlBuilder.get(), values, {
    headers: { "Content-Type": "application/merge-patch+json" },
  });

  return response.data;
};

const launchPremiumFeatureConnectorDispatchCircuitRuleGet = async (action, dispatchCircuitRuleId, values) => {
  const urlBuilder = new QueryUrlBuilderService(
    "dispatch-circuit-rules/" + dispatchCircuitRuleId + "/launch-premium-feature-connector"
  ).withFilters({ action: action, ...values });

  const response = await Api.new().get(urlBuilder.get(), values);
  return response.data;
};

export default {
  fetchConnectorById,
  fetchConnectorList,
  fetchConnectorOrganizationList,
  fetchConfigurationById,
  createConfiguration,
  updateConfiguration,
  deleteConfiguration,
  launchPremiumFeatureConnector,
  launchPremiumFeatureConnectorDispatchCircuitRulePatch,
  launchPremiumFeatureConnectorDispatchCircuitRuleGet,
};
